import { render, staticRenderFns } from "./RedirectPage.vue?vue&type=template&id=eb8c240e&scoped=true&"
import script from "./RedirectPage.vue?vue&type=script&lang=js&"
export * from "./RedirectPage.vue?vue&type=script&lang=js&"
import style0 from "./RedirectPage.vue?vue&type=style&index=0&id=eb8c240e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8c240e",
  null
  
)

export default component.exports